import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Count from './comps/Count.js';

import discord from '../../../assets/images/discord-blue.svg';
import secret from '../../../assets/images/secret.jpg';

const Countdown = () => {

    return (
        <section className="countdown" id="something-big">
            <div className="container mx-auto">
                <div className="flex flex-col lg:flex-row align-start countdown-container">
                    <div className="w-full lg:w-5/12 xl:w-1/2">
                        <img className="secret" src={secret} alt="metafans clubhouse countdown"></img>
                    </div>
                    <div className="w-full lg:w-7/12 xl:w-1/2 pl-5 pr-5 countdown-info ml-5">
                        <h1 className="lt-white font-bold">It's Coming. Clubhouse is your Digital Country Club.</h1>
                        <p className="text-dk-grey font-bold info">The Metafans Clubhouse is almost here! If you want full access to all our games, prizes, and digital experiences, you will need a Genesis Metafan by August 15th at 8pm EST.</p>
                        {/* Phase 2 */}
                        <div className="launch-countdown lt-white p-3">
                            <div className="text-center">
                                <h2>Secure your spot, Mint today.</h2>
                                <p className="launch-date accent-green mb-0 mt-3">August 15, 2022 at 8 PM EST</p>
                            </div>
                            <div className="flex justify-center items-center countdown-meter pl-5 pr-5 pt-3 text-center">
                                <Count/>
                            </div>
                            <div className="p-3 pt-4 text-center footer-count-notes">
                                <a href="https://discord.com/invite/5RrNCnvRny" target="_blank" className="discord flex justify-center items-center">
                                    <img src={discord} alt="join our discord"></img>
                                    <p className="lt-white font-bold">Join our discord community</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Countdown;